import { useEffect } from "react";

const DEFAULT_TITLE = "Holideviser — Travel like the local-with-good-taste you wish you knew";

// Lightweight SEO: sets document title + meta description per page (Step 20).
export const useSeo = ({ title, description }) => {
  useEffect(() => {
    if (title) document.title = title;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    const prev = meta.getAttribute("content");
    if (description) meta.setAttribute("content", description);
    return () => {
      document.title = DEFAULT_TITLE;
      if (prev != null) meta.setAttribute("content", prev);
    };
  }, [title, description]);
};
